var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import TextArea from "../../../../../../../shared-library/components/TextAreaField";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import { accountDetails } from "@salesdi";
var DncStatus = function () {
    var _a = __read(useState([]), 2), dncStd = _a[0], setDncStd = _a[1];
    var _b = __read(useState(), 2), selectedDNCStd = _b[0], setSelectedDNCStd = _b[1];
    var _c = __read(useState(null), 2), dncPendingSts = _c[0], setDncPendingSts = _c[1];
    var _d = __read(useState(), 2), remark = _d[0], setRemark = _d[1];
    var _e = __read(useState(false), 2), saveDNCSuccessFull = _e[0], setSaveDNCSuccessFull = _e[1];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    useEffect(function () {
        di.clients.DNCSTD().then(function (val) {
            setDncStd(val.map(function (x) {
                return {
                    value: x.taskCat_ID,
                    display: x.taskCat_Name,
                };
            }));
        });
        if (selectedAccount.accountCode)
            di.clients
                .DNCPendingStatus({ acCode: selectedAccount.accountCode })
                .then(function (val) {
                setDncPendingSts(val);
            });
        return function () { return setSaveDNCSuccessFull(false); };
    }, []);
    var saveDNC = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
                        clientRemarks: remark
                    };
                    return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    payload = (_a.createdBy = _b.sent(),
                        _a.stBriefID = selectedDNCStd,
                        _a);
                    di.clients.DNCData(payload).then(function (val) {
                        if (val.strMsg === "1")
                            setSaveDNCSuccessFull(true);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "dnc-body" },
        dncPendingSts && dncPendingSts.DNCStatus == "Pending For Approval" && (React.createElement("div", { className: "txt-dark-red DMSanN_16_400" },
            "Account code: ",
            dncPendingSts.AcCode,
            " request already raised but pending for approval")),
        React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "Standard Response"),
        React.createElement(SelectDropdown, { placeholderClassName: "DMSanN_16_400", dropdownOptions: dncStd, downarrow: "edel-icon-arrow-down", className: "leadpage-selectdropdown", defaultValue: selectedDNCStd, onChangeEvent: function (e) {
                setSelectedDNCStd(e.target.value);
            } }),
        React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "Remark"),
        React.createElement(TextArea, { id: "message", name: "message", placeholderClassName: "DMSanM_14_500 txt_blackOne1", value: remark, onChangeEvent: function (e) {
                setRemark(e.target.value);
            } }),
        saveDNCSuccessFull && (React.createElement("div", { className: "DMSanN_14_400 txt_primaryGrey d-flex justify-content-center m-2" }, "Data Saved Successfully")),
        React.createElement("div", { className: "d-flex align-items-center justify-content-center dnc-btns" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save", onClick: function () { return saveDNC(); }, disabled: !remark || !selectedDNCStd }),
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Reset", onClick: function () {
                    setSelectedDNCStd("");
                    setRemark("");
                    setSaveDNCSuccessFull(false);
                } }))));
};
export default DncStatus;
